module.exports = __webpack_public_path__ + "static/media/2.5b9880f5.png";